import { Sparkles } from 'lucide-react';
import { cn } from '../../lib/utils';

/** Ava's mark: a teal-to-gold orb with a spark. `pulse` while she's working. */
export function AvaAvatar({ size = 'md', pulse = false, className }: { size?: 'sm' | 'md' | 'lg' | 'xl'; pulse?: boolean; className?: string }) {
  const dims = { sm: 'h-7 w-7', md: 'h-9 w-9', lg: 'h-12 w-12', xl: 'h-16 w-16' }[size];
  const icon = { sm: 'h-3.5 w-3.5', md: 'h-4 w-4', lg: 'h-6 w-6', xl: 'h-7 w-7' }[size];
  return (
    <div className={cn('relative shrink-0', dims, className)}>
      {pulse && <span className="absolute inset-0 rounded-full bg-brand/30 animate-ping" />}
      <div className={cn('relative flex items-center justify-center rounded-full bg-gradient-to-br from-brand-light via-brand to-accent shadow-brand', dims)}>
        <Sparkles className={cn('text-white drop-shadow', icon)} />
      </div>
    </div>
  );
}
